import React, { FC, useState } from 'react'
import { Image } from '@/atoms/Image'
import { TitleLG } from '@/atoms/Text'
import { BasicCarousel } from '@/molecules/BasicCarousel'
import { GiveawayPartnerLogo, Maybe } from '@/types/codegen-contentful'
import { useTranslate } from '@/utils/translate/translate-client'
import { Lightbox } from './Lightbox'

interface GalleryCarousel {
  galleryImages: Maybe<GiveawayPartnerLogo>[]
}

export const GalleryCarousel: FC<GalleryCarousel> = ({ galleryImages }) => {
  const { t } = useTranslate('tickets')

  const [isLightboxOpen, setIsLightboxOpen] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  const openLightbox = (index: number) => {
    setCurrentImageIndex(index)
    setIsLightboxOpen(true)
  }

  return (
    <section className="flex flex-col gap-4">
      <TitleLG color="black" className="md:photon-heading-sm mb-3 font-semibold md:font-bold">
        {t('showImages', 'Show Images')}
      </TitleLG>
      <BasicCarousel showGradients containerClassName="!gap-2 !px-2">
        {!!galleryImages?.length &&
          galleryImages.map((image, index) => (
            <Image
              key={image?.sys.id}
              src={image?.imageUrl || ''}
              alt={image?.altText || ''}
              width={288}
              height={162}
              quality={50}
              className="rounded-lg object-contain object-center"
              onClick={() => openLightbox(index)}
            />
          ))}
      </BasicCarousel>
      {isLightboxOpen && (
        <Lightbox
          showImages={galleryImages}
          currentImageIndex={currentImageIndex}
          setIsLightboxOpen={setIsLightboxOpen}
          setCurrentImageIndex={setCurrentImageIndex}
        />
      )}
    </section>
  )
}
